<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="mdi-newspaper"
        :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mb-5">
        <v-col class="text-right" cols="12">
          <v-btn
              color="primary"
              @click="addNews"
          >
            Thêm tin tức
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center" class="mt-n6 " justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="news"
              :items-per-page="10"
              class="elevation-1">
            <template v-slot:item.photo_url="{ item }">
              <img :src="url + item.photo_url ? url + item.photo_url : require('@/assets/images/logo_Eglife1.png')"
                   width="100">
            </template>
            <template v-slot:item.created_at="{item}">
              <div>{{ formatDateTime(item.created_at) }}</div>
            </template>
            <template v-slot:item.highight="{ item }">
              <v-switch
                  v-model="item.highight"
                  class="pa-3"
                  :value="item.highight"
                  @click="updateHighlight(item.id)"
              ></v-switch>
            </template>
            <template v-slot:item.active="{ item }">
              <v-switch
                  v-model="item.active"
                  class="pa-3"
                  :value="item.active"
                  @click="updateActive(item.id)"
              ></v-switch>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DELETE_NEWS, GET_DETAIL_NEWS, GET_LIST_NEWS, UPDATE_NEWS} from "@/store/modules/news";


export default {
  name: "News",
  data() {
    return {
      page: "Danh sách tin tức",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách tin tức",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {text: 'Ảnh bìa', value: 'photo_url', sortable: false},
        {text: 'Tên', value: 'name'},
        {text: 'Thời gian', value: 'created_at'},
        {text: 'Lươt xem', value: 'count_view'},
        {text: 'Tin nổi bật', value: 'highight'},
        {text: 'Hiển thị', value: 'active'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      url: '',
      selected: -1,
      highlight:-1
    }
  },
  computed: {
    ...mapGetters({
      news: "news",
      newsDetail: "newsDetail",
    }),
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_LIST_NEWS);
  },
  methods: {
    formatDateTime(date) {
      if (!date) return null
      const newDate = new Date(date)
      const [year, month, day] = [newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()]
      return `${day} / ${month} / ${year}`
    },
    addNews() {
      this.$router.push('/news/add_news')
    },
    async updateActive(id) {
      await this.$store.dispatch(GET_DETAIL_NEWS, id)
      this.news.forEach(item => {
        if (item.id == id) {
          this.selected = item.active == true ? 1 : 0
        }
      })
      this.newsDetail.active = this.selected
      await this.$store.dispatch(`${UPDATE_NEWS}`, this.newsDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/news')
        } else {
          alert(data.data.errors)
        }
      });
    },
    async updateHighlight(id){
      await this.$store.dispatch(GET_DETAIL_NEWS, id)
      this.news.forEach(item => {
        if (item.id == id) {
          this.highlight = item.highight == true ? 1 : 0
        }
      })
      this.newsDetail.highight = this.highlight
      await this.$store.dispatch(`${UPDATE_NEWS}`, this.newsDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/news')
        } else {
          alert(data.data.errors)
        }
      });
    },
    deleteItem(id) {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_NEWS}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_NEWS);
        }
      })
    },
    editItem(id) {
      this.$router.push({
        path: "/news/edit_news/" + id,
      });
    },
  }
}
</script>

<style scoped>

</style>